import React, { Component } from "react";
import { addDays, differenceInCalendarDays, format, parse } from "date-fns";
import B2BWidgets from "../../../b2bwidgets/index";
import DesktopCalender from "../../../calendar/hotelCalender/theme4/DesktopCalender";
import HotelAutoComplete from "./HotelAutoComplete";
import NationalityDropdownComp from "../../../NationalityDropDown/index";
import cf from "../../../../lib/utils/common";
import getNationalitiesList from "../../../../lib/getNationalitiesList";
import getCountriesList from "../../../../lib/getCountriesList";
import HotelAdvSearch from "./HotelAdvSearch";
import { checksession } from "../../../../lib/checksession.js";
import MobileCalender from "../../../calendar/hotelCalender/theme4/MobileCalender";
import ModalPopupComponent from "../../../ModalPopupComponent/theme5/ModalPopupComponent";
import { offlineCreateEnquiry } from "../../../../../common/lib/enquiry";
import { getCity } from "../../../../../common/lib/myProfile";
import CountryDropdownComp from "../../../CountryDropdown/index";
import { leadingSpaces } from "../../../../lib/utils/regex_cheat_sheet";

const childAgeList = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
];
let regions = "";
let indexDropdown = -1;
let search_text = "";
let destination_id = "";
let search_type = "";
let bookingType = [
  {
    name: "business",
    value: "Business",
    label: "Business",
    tripId: 1,
    selected: false,
    show: false,
  },
  {
    name: "annual",
    value: "Annual Trip",
    label: "Annual Trip",
    tripId: 2,
    selected: false,
    show: false,
  },
  {
    name: "personal",
    value: "Personal",
    label: "Personal",
    tripId: 3,
    selected: false,
    show: false,
  },
  {
    name: "exceptional",
    value: "Exceptional",
    label: "Exceptional",
    tripId: 4,
    selected: false,
    show: false,
  },
];
export default class Theme1 extends Component {
  constructor(props) {
    super(props);
    this.setScrollDown = React.createRef();
    this.wrapperRef = React.createRef();
    this.advanceSearchWrapper = React.createRef();
    this.guestDetailWrapper = React.createRef();
    this.bfSearchWrapper = React.createRef();
    this.rtSearchWrapper = React.createRef();
    this.starSearchWrapper = React.createRef();
    this.state = {
      hotelName: "",
      expandHotelNameBoolean: false,
      checkInOutValue: "",
      checkInValue: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
      checkOutValue: cf.getDateWithFormat(
        addDays(
          new Date(),
          this.props.getDefaultDays ? this.props.getDefaultDays : 2
        ),
        this?.props?.dateFormat
      ),
      dateLimit: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
      openRoomDetailList: false,
      expandCheckInOutDateBoolean: false,
      selectedRoomDetails: { rooms: 1, guest: 1, adult: 1, child: 0 },
      getAutoSuggestList: this.props.getAutoSuggestList,
      isError: {
        hotelName: false,
        checkInOutDate: false,
        roomGuest: false,
        selectedNationality: false,
        selectedGuest: false,
        colleagueError: false,
        showbookingTypeError: false,
        countryOfResidence: false,
      },
      getDestinationId: "",
      getSearchType: "",
      roomList: [
        {
          id: 1,
          adults: 1,
          children: 0,
          adultAddCountDisable: false,
          adultMinusCountDisable: false,
          childrenAddCountDisable: false,
          childrenMinusCountDisable: true,
          childDetails: [],
        },
      ],
      // finalRoomList: [{ id: 1, adults: 2, children: 0, childDetails: [] }],
      finalRoomList: [
        {
          id: 1,
          adults: 1,
          children: 0,
          adultAddCountDisable: false,
          adultMinusCountDisable: true,
          childrenAddCountDisable: false,
          childrenMinusCountDisable: true,
          childDetails: [],
        },
      ],
      type: "hotel",
      openTraveler: false,
      advSearch: false,
      nationallitySearch: "",
      is_breakfast: "",
      // isBreakfastChecked: false,
      originCountries: [],
      selectedNationality: { value: "", countryCode: null },
      response: [],
      isOneStar: false,
      isTwoStar: false,
      isThreeStar: false,
      isFourStar: false,
      isFiveStar: false,
      selectedCheckBoxes: {},
      guest_id: "",
      showStarSearch: false,
      showRoomTypeSeach: false,
      showBreakfastSearch: false,
      allStar: false,
      clientNationality: { value: "", countryCode: null },
      countryOfResidence: { value: "", label: "", flag: "", countryCode: "" },
      countriesResidenceList: [],
      bookingTypeId: 1,
      userProfileId: this.props?.userProfile,
      bookingType: [
        {
          name: "business",
          value: "Business",
          label: "Business",
          tripId: 1,
          selected: false,
          show: false,
        },
        {
          name: "annual",
          value: "Annual Trip",
          label: "Annual Trip",
          tripId: 2,
          selected: false,
          show: false,
        },
        {
          name: "personal",
          value: "Personal",
          label: "Personal",
          tripId: 3,
          selected: false,
          show: false,
        },
        {
          name: "exceptional",
          value: "Exceptional",
          label: "Exceptional",
          tripId: 4,
          selected: false,
          show: false,
        },
      ],
      isguestChecked: this.props?.isguestChecked || false,
      employeeguestId: [],
      onLoadPopup: false,
      enquiry_id: "",
      selectedHotel: [],
      showbookingTypeError: false,
      guestBookingType: [...bookingType],
      modalPopupValue: "",
      isLoading: false,
      countryList: [],
      pickuploc: "",
      selectedCountry: "",
      selectedCountryLocation: "",
      selectedHotelAddress: "",
      isErrloc: "",
      btnLoader: false,
      etPolicy: false,
      colleagueEtRule: {},
    };
  }

  // Nationality


  handleBreakfastSelection = (event, index) => {
  const { checked } = event.target;
  
  this.setState((prev) => {
    const currentSelection = prev.selectedCheckBoxes.breakfast || [false, false, false];
    const updatedSelections = [...currentSelection];
    
    // Update the specific index
    updatedSelections[index] = checked;
    
    // If an individual option is unchecked, uncheck "All"
    if (!checked) {
      updatedSelections[2] = false;
    }
    
    // If both individual options are checked, check "All"
    if (updatedSelections[0] && updatedSelections[1]) {
      updatedSelections[2] = true;
    }
    
    return {
      selectedCheckBoxes: {
        ...prev.selectedCheckBoxes,
        breakfast: updatedSelections,
      },
    };
  });
};


  handleBreakfastAllSelection = (event) => {
  const { checked } = event.target;
  
  this.setState((prev) => ({
    selectedCheckBoxes: {
      ...prev.selectedCheckBoxes,
      breakfast: checked ? [true, true, true] : [false, false, false],
    },
  }));
};

  componentDidMount() {
    let countryFlagList = [];
    getCity().then((res) => {
      if (res && res.data && res.data.length > 0) {
        console.log(res, "res");
        res.data.map((fact, index) => {
          countryFlagList.push({
            value: fact.city_name,
            isdCode: fact.city_name,
            countryCode: fact.city_name,
            // flag: fact.contry_flag,
            // countryFlag: fact.contry_flag,
            countryId: index,
            countryName: fact.city_contry[0].name || "",
          });
        });
        this.setState({ countryList: [...countryFlagList] });
      }
    });

    //Trip Type
    // Nationality
    getNationalitiesList().then((resp) => {
      let nationalityList = [];
      if (resp?.data?.data.length > 0) {
        resp?.data.data.map((item) => {
          nationalityList.push({
            ...item,
            value: item.nationality_name,
            countryCode: item.nationality_code,
          });
        });
      }
      this.setState({ originCountries: nationalityList });
    });

    // Fetch Country of Residence list
    getCountriesList().then((resp) => {
      let countriesList = [];
      if (resp?.data?.length > 0) {
        resp.data.map((item) => {
          countriesList.push({
            ...item,
            value: item.contry_name,
            countryCode: item.contry_code,
            flag: item.contry_flag,
          });
        });
      }
      this.setState({ countriesResidenceList: countriesList });
    }).catch((error) => {
      console.error("Error fetching countries list:", error);
    });

    regions = new URLSearchParams(window.location.search).get("region");
    if (
      !cf.isValueEmpty(this.props) &&
      this.props.isSRP === true &&
      !cf.isValueEmpty(this.props.query)
    ) {
      console.log("this.props.query=>", this.props.query);

      let checkInArr = this.props?.query?.checkin?.split("-");
      let checkOutArr = this.props?.query?.checkout?.split("-");
      let checkInValue = cf.getDateWithFormat(
        new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
        this?.props?.dateFormat
      );
      let checkOutValue = cf.getDateWithFormat(
        new Date(checkOutArr[0], Number(checkOutArr[1]) - 1, checkOutArr[2]),
        this?.props?.dateFormat
      );
      let checkInOut =
        cf.getDateWithFormat(
          new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
          this?.props?.dateFormat
        ) +
        " - " +
        cf.getDateWithFormat(
          new Date(checkOutArr[0], Number(checkOutArr[1]) - 1, checkOutArr[2]),
          this?.props?.dateFormat
        );
      let roomsdetail = this.props.query.rooms.split("_");
      let totalRooms = roomsdetail.length;
      let totalAdult = 0;
      let totalChildren = 0;
      let roomListArr = [];
      let finalRoomListArr = []; //new
      roomsdetail.map((ele, index) => {
        let split = ele.split("-").filter((item) => item);
        totalAdult = Number(split[0].charAt(0)) + totalAdult;
        totalChildren = Number(split[1].charAt(0)) + totalChildren;
        roomListArr = [
          ...roomListArr,
          {
            id: index + 1,
            adults: Number(split[0].charAt(0)),
            children: Number(split[1].charAt(0)),
            adultAddCountDisable: false,
            adultMinusCountDisable: index + 1 > 1 ? true : false,
            childrenAddCountDisable: false,
            childrenMinusCountDisable:
              Number(split[1].charAt(0)) == 1 ? false : true,
            childDetails: [],
          },
        ];
        // finalRoomListArr = [...finalRoomListArr, { id: index + 1, adults: Number(split[0].charAt(0)), children: Number(split[1].charAt(0)), childDetails: [] }] //new
        // split.map((element, id) => {
        //     if (id > 1) roomListArr[index].childDetails = [...roomListArr[index].childDetails, { age: element, isOpen: false, isError: false }],
        //         finalRoomListArr[index].childDetails = [...finalRoomListArr[index].childDetails, { age: Number(element) }]
        // })
        split.map((element, id) => {
          if (id > 1)
            roomListArr[index].childDetails = [
              ...roomListArr[index].childDetails,
              { age: element, isOpen: false, isError: false },
            ];
        });
      });
      this.setState(
        {
          checkInOutValue: checkInOut,
          checkInValue: checkInValue,
          checkOutValue: checkOutValue,
          getDestinationId: this.props.query.destid,
          getSearchType: this.props.query.search_type,
          hotelName: this.props.query.region + ", " + this.props.query.country,
          selectedRoomDetails: {
            rooms: totalRooms,
            guest: totalAdult + totalChildren,
            adult: totalAdult,
            child: totalChildren,
          },
          roomList: roomListArr,
          nationallitySearch: this.props.query.nationality,
          countryOfResidence: {
            value: "",
            label: "",
            flag: "",
            countryCode: this.props.query.source_country || "",
          },
          // response:this.props.query.ratings,
          guest_id: this.props.query.guestId,
          bookingTypeId: this.props.query.bookingType,
          employeeguestId:
            this.props?.query?.employeeGuest?.length > 0
              ? this.props?.query?.employeeGuest
              : [],
        },
        this.setState((prevState) => ({
          ...prevState.selectedCheckBoxes,
          selectedCheckBoxes: {
            breakfast: [
              this.convertToBoolean(this.props.query?.bf),
              this.convertToBoolean(this.props.query?.withoutbf),
            ],
            room_type: [
              this.convertToBoolean(this.props.query?.rf),
              this.convertToBoolean(this.props.query?.nonrf),
            ],
          },
        })),
        () => {
          this.bookingTypeMethod(Number(this.props.query.bookingType));
          this.checkRoomDetails();
        }
      );
      const deepClone = JSON.parse(JSON.stringify(roomListArr));
      this.setState({
        finalRoomList: deepClone,
      });
    } else {
      if (regions != null && regions != "" && regions != undefined) {
        this.renderInfo();
      }
      this.setState({
        checkInOutValue: this.getCheckInOutValue(
          this.state.checkInValue,
          this.state.checkOutValue
        ),
      });
    }
    document.addEventListener("mousedown", this.handleClickOutside);
    this.bookingTypeComp();
    // document.addEventListener('mousedown', function(e){ e.preventDefault(); }, false)
  }

  convertToBoolean(value) {
    return value && value.trim() !== "" ? true : false;
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  checkRoomDetails() {
    let { roomList } = this.state;
    roomList.map((ele, index) => {
      let totalAccomodation = ele.adults + ele.children;
      if (totalAccomodation <= 12) {
        if (totalAccomodation === 12) {
          roomList[index].adultAddCountDisable = true;
          roomList[index].childrenAddCountDisable = true;
        } else if (totalAccomodation < 12) {
          if (
            roomList[index].adultAddCountDisable === true &&
            roomList[index].childrenAddCountDisable === true
          ) {
            roomList[index].adultAddCountDisable = false;
            roomList[index].childrenAddCountDisable = false;
          }
          if (roomList[index].adults > 1) {
            roomList[index].adultMinusCountDisable = false;
          } else if (roomList[index].adults === 1) {
            roomList[index].adultMinusCountDisable = true;
            roomList[index].adultAddCountDisable = false;
          }
          if (roomList[index].children > 1) {
            roomList[index].childrenMinusCountDisable = false;
          } else if (roomList[index].children > 0) {
            roomList[index].childrenMinusCountDisable = false;
            roomList[index].childrenAddCountDisable = false;
          }
        }
      }
    });
    this.setState({ roomList: [...roomList] });
  }
  handleClickOutside = (e) => {
    if (
      this.dropdownWrapperRef &&
      !this.dropdownWrapperRef.contains(e.target)
    ) {
      if (this.props.expandHotelNameBoolean === true)
        this.props.expandHotelNameBooleanfunc(false);
      // if (
      //   this.advanceSearchWrapper.current &&
      //   !this.advanceSearchWrapper.current.contains(event.target)
      // ) {
      //   this.setState({ advSearch: false });
      // }
      if (
        this.guestDetailWrapper.current &&
        !this.guestDetailWrapper.current.contains(e.target)
      ) {
        this.setState({ openTraveler: false });
      }

      if (
        this.state.expandCheckInOutDateBoolean === true ||
        this.state.openRoomDetailList === true
      ) {
        this.setState({
          expandCheckInOutDateBoolean: false,
          openRoomDetailList: false,
        });
      }
    }

    if (
      this.rtSearchWrapper.current &&
      !this.rtSearchWrapper.current.contains(event.target)
    ) {
      this.setState({ showRoomTypeSeach: false });
    }
    if (
      this.bfSearchWrapper.current &&
      !this.bfSearchWrapper.current.contains(event.target)
    ) {
      this.setState({ showBreakfastSearch: false });
    }
    if (
      this.starSearchWrapper.current &&
      !this.starSearchWrapper.current.contains(event.target)
    ) {
      this.setState({ showStarSearch: false });
    }
  };

  setDropdownWrapperRef = (node) => {
    this.dropdownWrapperRef = node;
  };
  onClickDoneButton = () => {
    let totalGuest = 0;
    let count = 0;
    let Validation = true;
    let validation_arr = [];
    let roomList = this.state.roomList;
    let totalAdult = 0;
    let totalChilds = 0;
    // let finalRoomListArr = []; //new

    while (count <= roomList.length) {
      if (
        !cf.isValueEmpty(roomList[count]) &&
        !cf.isValueEmpty(roomList[count].childDetails) &&
        roomList[count].childDetails.length > 0
      ) {
        // finalRoomListArr = [...finalRoomListArr, { id: count + 1, adults: roomList[count].adults, children: roomList[count].children, childDetails: [{ age: '' }] }] //new
        roomList[count].childDetails.map((element, index) => {
          if (cf.isValueEmpty(element.age)) {
            roomList[count].childDetails[index].isError = true;
          }
        });
        // Validation = roomList[count].childDetails.every(item => !cf.isValueEmpty(item.age));
        validation_arr.push(
          roomList[count].childDetails.every(
            (item) => !cf.isValueEmpty(item.age)
          )
        );
        let checker = validation_arr.every(Boolean);
        Validation = checker;
      }
      count++;
    }
    // this.setState({ roomList: [...roomList] })
    this.setState({ roomList: [...roomList] }, () => {
      if (Validation === true) {
        this.state.roomList.length > 0 &&
          this.state.roomList.map((element) => {
            totalGuest = totalGuest + element.adults + element.children;
            totalAdult = totalAdult + element.adults;
            totalChilds = totalChilds + element.children;
            //new
            // element.childDetails.map((ele, i) => {
            //     finalRoomListArr[idx].childDetails[i].age = ele.age;
            // })
          });
        this.setState({
          // finalRoomList: finalRoomListArr,
          selectedRoomDetails: {
            rooms: this.state.roomList.length,
            guest: totalGuest,
            adult: totalAdult,
            child: totalChilds,
          },
        });
        const deepClone = JSON.parse(JSON.stringify(roomList));
        this.setState({
          finalRoomList: deepClone,
        });
        if (this.state.openRoomDetailList === true) {
          this.setState({ openRoomDetailList: false });
        }
      }
    });
  };
  removeRoomItem = (id) => {
    const filteredRoom = this.state.roomList.filter((item) => item.id !== id);
    this.setState({ roomList: [...filteredRoom] });
  };

  addAccomodationCount = async (id, index, type) => {
    let { roomList } = this.state;
    if (type === "adult") {
      if (roomList[index].id === id) {
        roomList[index].adults = roomList[index].adults + 1;
      }
    } else {
      if (roomList[index].id === id) {
        roomList[index].children = roomList[index].children + 1;
        roomList[index].childDetails = [
          ...roomList[index].childDetails,
          { age: "", isOpen: false, isError: false },
        ];
      }
    }
    let totalAccomodation = roomList[index].adults + roomList[index].children;
    if (totalAccomodation <= 7) {
      if (totalAccomodation === 7) {
        roomList[index].adultAddCountDisable = true;
        roomList[index].childrenAddCountDisable = true;
      } else if (totalAccomodation < 7) {
        if (
          roomList[index].adultAddCountDisable === true &&
          roomList[index].childrenAddCountDisable === true
        ) {
          roomList[index].adultAddCountDisable = false;
          roomList[index].childrenAddCountDisable = false;
        }
      }
      if (roomList[index].adults > 1) {
        roomList[index].adultMinusCountDisable = false;
      }
      if (roomList[index].children > 0) {
        roomList[index].childrenMinusCountDisable = false;
      }
      await this.setState({ roomList: [...roomList] });
    }
  };
  minusAccomodationCount = async (id, index, type) => {
    let { roomList } = this.state;
    if (type === "adult") {
      if (roomList[index].id === id) {
        if (roomList[index].adults >= 2) {
          roomList[index].adults = roomList[index].adults - 1;
          roomList[index].adultMinusCountDisable = false;
          if (roomList[index].adultAddCountDisable === true) {
            roomList[index].adultAddCountDisable = false;
          }
          if (roomList[index].childrenAddCountDisable === true) {
            roomList[index].childrenAddCountDisable = false;
          }
        } else if (roomList[index].adults === 1) {
          roomList[index].adultMinusCountDisable = true;
        }
      }
    } else {
      if (roomList[index].id === id) {
        roomList[index].childDetails.pop();
        if (roomList[index].children >= 1) {
          roomList[index].children = roomList[index].children - 1;
          roomList[index].childrenMinusCountDisable = false;
          if (roomList[index].childrenAddCountDisable === true) {
            roomList[index].childrenAddCountDisable = false;
          }
          if (roomList[index].adultAddCountDisable === true) {
            roomList[index].adultAddCountDisable = false;
          }
        } else if (roomList[index].children === 0) {
          roomList[index].childrenMinusCountDisable = true;
        }
      }
    }
    await this.setState({ roomList: [...roomList] });
  };
  isChildrenAge = (index, ind, type, age) => {
    let { roomList } = this.state;
    if (type === "isOpen") {
      roomList[index].childDetails.forEach((child, childIndex) => {
        if (childIndex !== ind) {
          // Close all except the clicked one
          child.isOpen = false;
        }
      });
    }
    if (type === "isOpen") {
      roomList[index].childDetails[ind].isOpen =
        !roomList[index].childDetails[ind].isOpen;
    } else {
      roomList[index].childDetails[ind].age = age;
      roomList[index].childDetails[ind].isOpen = false;
      if (roomList[index].childDetails[ind].isError === true) {
        roomList[index].childDetails[ind].isError = false;
      }
    }
    this.setState({ roomList: [...roomList] });
  };
  onChangeCheckInOutValue = (value, type) => {
    if (type === "startDate") {
      this.setState({ checkInValue: value });
    } else if (type === "endDate") {
      let differenceInDays = differenceInCalendarDays(
        new Date(value),
        new Date(this.state.checkInValue)
      );
      if (differenceInDays === 0) {
        this.setState({ checkOutValue: addDays(new Date(value), 1) }, () => {
          if (!cf.isValueEmpty(value)) {
            let checkInOut =
              cf.getDateWithFormat(
                this?.state?.checkInValue,
                this?.props?.dateFormat
              ) +
              " - " +
              cf.getDateWithFormat(
                this?.state?.checkOutValue,
                this?.props?.dateFormat
              );
            this.setState({ checkInOutValue: checkInOut });
          }
        });
      } else {
        this.setState({ checkOutValue: value }, () => {
          if (!cf.isValueEmpty(value)) {
            let checkInOut =
              cf.getDateWithFormat(
                this?.state?.checkInValue,
                this?.props?.dateFormat
              ) +
              " - " +
              cf.getDateWithFormat(value, this?.props?.dateFormat);
            this.setState({ checkInOutValue: checkInOut });
          }
        });
      }
    }
  };

  onChangeSetHotelName = (value) => {
    this.setState(
      {
        hotelName: value.replace(leadingSpaces, ""),
        getDestinationId: "",
        selectedHotel: value,
      },
      () => {
        if (this.state.isError.hotelName === true) {
          this.validateErrorMsg();
        }
        this.props.getAutoSuggestValue(value);
      }
    );
  };
  validateErrorMsg = () => {
    const mapDispatch = {
      hotelName: cf.isValueEmpty(this.state.hotelName) ? true : false,
      checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue)
        ? true
        : false,
      roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails) ? true : false,
      selectedNationality: cf.isValueEmpty(this.state.selectedNationality.value)
        ? true
        : false,
      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
      colleagueError: cf.isValueEmpty(this.state.employeeguestId)
        ? true
        : false,
      // showbookingTypeError: true
    };
    this.setState({ isError: mapDispatch });
  };

  onButtonEnquiry() {
    this.setState({ isLoading: true }, () => {
      console.log(
        "ðŸš€ ~ Theme1 ~ onButtonEnquiry ~ onButtonEnquiry:",
        this.state.onLoadPopup
      );

      const mapDispatch = {
        hotelName:
          this.state.pickuploc || this.state.selectedHotelAddress
            ? false
            : true,
        checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue)
          ? true
          : false,
        roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails)
          ? true
          : false,
      };

      this.setState({ isError: mapDispatch }, () => {
        console.log(
          "ðŸš€ ~ Theme1 ~ this.setState ~ mapDispatch:",
          mapDispatch
        );

        let Validate = true;
        for (const [key, value] of Object.entries(this.state.isError)) {
          if (value === true) {
            Validate = false;
            break;
          }
        }

        console.log("Validate", Validate);

        if (Validate) {
          this.createEnquiry();
        } else {
          this.setState({ isLoading: false }); // Stop loading if validation fails
        }
      });
    });
  }

  createEnquiry = () => {
    console.log(
      "eleffment",
      this.state.selectedHotel,
      this.state.selectedRoomDetails,
      this.state.roomList
    );

    let hotelDetail = this.state.selectedHotel;
    let roomDetail = this.state.roomList.map((ele) => {
      return {
        adult_count: ele.adults,
        childs: ele.childDetails,
      };
    });

    let data = {
      site_id: this.props.home?.data?.site?.id || "",
      service_type: "hotel",
      remark: "Special request",
      service_data: {
        search_req: {
          site_id: this.props.home?.data?.site?.id  || "",
          destination_id: hotelDetail?.destination_id || "",
          hotel_name: this.state.selectedHotelAddress || "",
          city_name: this.state.pickuploc || "",
          country_name: this.state.selectedCountryLocation || "",
          search_type: hotelDetail?.search_type || "",
          is_etrule: true,
          nationality: this.state.nationallitySearch || "",
          currency: this.props?.userProfile?.agent_balance?.currency || "",
          check_in_date: format(
            new Date(this.state.checkInValue),
            "yyyy-MM-dd"
          ),
          check_out_date: format(
            new Date(this.state.checkOutValue),
            "yyyy-MM-dd"
          ),
          no_of_rooms: this.state.selectedRoomDetails?.rooms,
          hotel_ids: [hotelDetail?.destination_id] || [],
          rooms: roomDetail,
        },
      },
    };

    offlineCreateEnquiry(data)
      .then((res) => {
        console.log("ðŸš€ ~ Theme1 ~ offlineCreateEnquiry ~ res:", res);

        this.setState({
          enquiry_id: res.enquiry_id,
          onLoadPopup: true,
          isLoading: false, // Stop loading after the enquiry is created
        });
      })
      .catch((error) => {
        console.error("Error creating enquiry:", error);
        this.setState({ isLoading: false }); // Stop loading in case of an error
      });
  };

  generateSelection = (value) => {
    if (value === true) {
      return [true, null];
    } else if (value === false) {
      return [null, true];
    } else {
      return [null, null];
    }
  };

  onClickSearchHotel = () => {
    let colleagueslength = parseFloat(this?.state?.employeeguestId?.length);
    this.props.expandHotelNameBooleanfunc(false);
    let parentBookingTD = this.state.bookingType.filter((res) => res.selected);
    let colleagueBookingTD = this.state.guestBookingType.filter(
      (res) => res.show
    );

    let isParentInColleague = parentBookingTD.some((parent) =>
      colleagueBookingTD.some((colleague) => colleague.tripId === parent.tripId)
    );

    let mapDispatch = {
      hotelName: cf.isValueEmpty(this.state.hotelName) ? true : false,
      checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue)
        ? true
        : false,
      roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails) ? true : false,
      selectedNationality: cf.isValueEmpty(this.state.selectedNationality.value)
        ? true
        : false,
      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
      colleagueError: cf.isValueEmpty(this.state.employeeguestId)
        ? true
        : false,
      showbookingTypeError:
        !isParentInColleague &&
        this.props.userProfile.user_type == "TD" &&
        !this.state.isguestChecked &&
        this.state.guest_id?.length > 0 &&
        this.state.bookingTypeId != 4 &&
        !this.props.isSRP
          ? true
          : false,
    };
    
    // Validate Country of Residence
    if (this.props.isSRP) {
      // In SRP mode, only validate if value exists
      mapDispatch.countryOfResidence = cf.isValueEmpty(this.state.countryOfResidence.countryCode) ? false : true;
    } else {
      // In normal mode, validate as required
      mapDispatch.countryOfResidence = cf.isValueEmpty(this.state.countryOfResidence.countryCode) ? true : false;
    }
    if (mapDispatch.showbookingTypeError) {
      this.setState({ showbookingTypeError: true, modalPopupValue: "etRule" });
    }
    if (!this.props?.userProfile?.type) {
      mapDispatch.selectedNationality = cf.isValueEmpty(
        this.state.selectedNationality.value
      )
        ? false
        : true;
    }
    if (
      this.props?.userProfile?.type !== "B2B" ||
      this.props?.userProfile?.type !== "B2E"
    ) {
      mapDispatch.selectedNationality = cf.isValueEmpty(
        this.state.selectedNationality.value
      )
        ? true
        : false;
    }

    if (this.props.isOffline !== true) {
      mapDispatch.selectedGuest = cf.isValueEmpty(this.state.selectedGuest)
        ? false
        : true;
      // mapDispatch.colleagueError = cf.isValueEmpty(this.state.employeeguestId)
      //   ? false
      //   : true;
      // mapDispatch.colleagueError = this.state.selectedRoomDetails.rooms === colleagueslength ? false : true;
    }

    if (!this.props.isOffline) {
      mapDispatch.selectedGuest = cf.isValueEmpty(this.state.selectedGuest)
        ? false
        : true;
      // mapDispatch.colleagueError = cf.isValueEmpty(this.state.employeeguestId)
      //   ? false
      //   : true;
      // mapDispatch.colleagueError = this.state.selectedRoomDetails.rooms === colleagueslength ? false : true;
    }
    if (this.props.isSRP === true) {
      mapDispatch.selectedNationality = cf.isValueEmpty(
        this.state.selectedNationality.value
      )
        ? false
        : true;
      // Skip Country of Residence validation in SRP mode
      mapDispatch.countryOfResidence = false;
    }
    if (this.props.userProfile.type === "B2E") {
      if (this.props.userProfile.user_type == "CT" && !this.props.isSRP) {
        mapDispatch.colleagueError =
          this.state.bookingTypeId == 2 || this.state.bookingTypeId == 3
            ? false
            : this.state.selectedRoomDetails.rooms === colleagueslength
            ? false
            : true;
      }
      if (
        (this.props.userProfile.user_type == "TD" ||
          this.props.userProfile.user_type == "ADMIN") &&
        !this.state.isguestChecked
      ) {
        mapDispatch.colleagueError =
          this.state.guest_id?.length > 0
            ? false
            : this.props.isSRP && this?.props?.guestCheck
            ? false
            : true;
      }
    }
    mapDispatch.hotelName = this.state.getDestinationId ? false : true;
    let breakfastSelection = this.props.isModifySearch
      ? this.generateSelection(this.props?.filter?.is_breakfast)
      : this.state.selectedCheckBoxes?.breakfast;
    let roomTypeSelection = this.props.isModifySearch
      ? this.generateSelection(this.props?.filter?.is_refundable)
      : this.state.selectedCheckBoxes?.room_type;
    this.setState(
      (prevState) => ({
        ...prevState.selectedCheckBoxes,
        selectedCheckBoxes: {
          breakfast: breakfastSelection,
          room_type: roomTypeSelection,
        },
        isError: mapDispatch,
      }),
      () => {
        let Validate = true;
        for (const [key, value] of Object.entries(this.state.isError)) {
          if (value === true) {
            Validate = false;
            break;
          }
        }
        if (Validate === true) {
          this.setState({ btnLoader: true }, () => {
            let hotelNameArry = this.state.hotelName.split(",");
            let roomListArr = [];
            this.state.finalRoomList.map((res, id) => {
              roomListArr = [
                ...roomListArr,
                res.adults + "a-" + res.children + "c",
              ];
              res.childDetails.map((ele) => {
                roomListArr[id] = roomListArr[id].concat("-", ele.age);
              });
            });
            //IF CHECKOUT DATE IS EMPTY
            if (!this.state.checkOutValue) {
              this.state.checkOutValue = cf.getDateWithFormat(
                addDays(new Date(this.state.checkInValue), 2),
                this?.props?.dateFormat
              );
            }
            let starb2bFilter = this.props.isModifySearch
              ? this.props?.filter?.star_rating
              : [...new Set(this.state.response)];
            let bookingType = this.props.isSRP
              ? ""
              : this.state.bookingType?.filter((res) => res.selected);
            let urlQuery = {
              region: hotelNameArry[0]?.trim(),
              country:
                this.props.isSRP === true
                  ? hotelNameArry[1]?.trim()
                  : hotelNameArry[hotelNameArry.length - 1]?.trim(),
              checkin: format(new Date(this.state.checkInValue), "yyyy-MM-dd"),
              checkout: format(
                new Date(this.state.checkOutValue),
                "yyyy-MM-dd"
              ),
              rooms: roomListArr.join("_"),
              type: "location",
              roomtype: "single",
              page: 1,
              orderby: "desc",
              mop: "accrual",
              destid: this.state.getDestinationId,
              search_type: this.state.getSearchType,
              ratings: starb2bFilter.join("_"),
              bf: this.state.selectedCheckBoxes?.breakfast?.[0]
                ? this.state.selectedCheckBoxes?.breakfast?.[0]
                : null,
              withoutbf: this.state.selectedCheckBoxes?.breakfast?.[1]
                ? this.state.selectedCheckBoxes?.breakfast?.[1]
                : null,
              rf: this.state.selectedCheckBoxes?.room_type?.[0]
                ? this.state.selectedCheckBoxes?.room_type?.[0]
                : null,
              nonrf: this.state.selectedCheckBoxes?.room_type?.[1]
                ? this.state.selectedCheckBoxes?.room_type?.[1]
                : null,
              nationality: this.state.nationallitySearch,
              guestId: this.state.guest_id,
              is_web_app: false,
              hotelLocation: this.state.hotelName,
              bookingType:
                this.props.isSRP === true
                  ? this.props?.bookingType
                  : bookingType[0]?.tripId,
              guestCheck: this.state.isguestChecked,
              employeeGuest: this.state?.employeeguestId,
              isModifySearch: this.props.isModifySearch || false,
              vid: this.state.getDestinationId,
              etPolicy: this.state.etPolicy,
            };
            
            // Add Country of Residence to URL query
            // In SRP mode, preserve source country from existing query
            urlQuery.source_country = this.props.isSRP
              ? this.props?.query?.source_country || ""
              : this.state.countryOfResidence.countryCode;

            this.setState({ btnLoader: false });
            if (this.state.getSearchType == 21) {
              const searchParams = new URLSearchParams(urlQuery);
              const queryString = searchParams.toString();
              localStorage.setItem("hotel_srp", "");
              window.location = "/hotel/details?" + queryString;
              return;
            }
            if (this.props.isOffline === false) {
              cf.redirectTo("/hotel/search", urlQuery);
            } else if (this.props.isOffline === true) {
              const searchParams = new URLSearchParams(urlQuery);
              const queryString = searchParams.toString();
              localStorage.setItem("hotel_srp", JSON.stringify(urlQuery));
              window.location = "/offlinesearch/hotel?" + queryString;
            }
          });
        }
      }
    );
    // this.setState({ isError: mapDispatch }, () => {
    //   console.log("this.state.isError=>", this.state.isError);
    //   let Validate = true;
    //   for (const [key, value] of Object.entries(this.state.isError)) {
    //     if (value === true) {
    //       Validate = false;
    //       break;
    //     }
    //   }
    //   console.log("Validate=>", Validate);
    //   console.log("this.state.selectedCheckBoxes=>", this.state.selectedCheckBoxes);
    //   if (Validate === true) {
    //     let hotelNameArry = this.state.hotelName.split(",");
    //     let roomListArr = [];
    //     this.state.finalRoomList.map((res, id) => {
    //       roomListArr = [
    //         ...roomListArr,
    //         res.adults + "a-" + res.children + "c",
    //       ];
    //       res.childDetails.map((ele) => {
    //         roomListArr[id] = roomListArr[id].concat("-", ele.age);
    //       });
    //     });
    //     //IF CHECKOUT DATE IS EMPTY
    //     if (!this.state.checkOutValue) {
    //       this.state.checkOutValue = cf.getDateWithFormat(
    //         addDays(new Date(this.state.checkInValue), 2),
    //         this?.props?.dateFormat
    //       );
    //     }
    //     let starb2bFilter = [...new Set(this.state.response)];
    //     let bookingType = this.props.isSRP
    //       ? ""
    //       : this.state.bookingType?.filter((res) => res.selected);
    //     let urlQuery = {
    //       region: hotelNameArry[0]?.trim(),
    //       country:
    //         this.props.isSRP === true
    //           ? hotelNameArry[1]?.trim()
    //           : hotelNameArry[hotelNameArry.length - 1]?.trim(),
    //       checkin: format(new Date(this.state.checkInValue), "yyyy-MM-dd"),
    //       checkout: format(new Date(this.state.checkOutValue), "yyyy-MM-dd"),
    //       rooms: roomListArr.join("_"),
    //       type: "location",
    //       roomtype: "single",
    //       page: 1,
    //       orderby: "desc",
    //       mop: "accrual",
    //       destid: this.state.getDestinationId,
    //       search_type: this.state.getSearchType,
    //       ratings: starb2bFilter.join("_"),
    //       bf: this.state.selectedCheckBoxes?.breakfast?.[0]
    //         ? this.state.selectedCheckBoxes?.breakfast?.[0]
    //         : null,
    //       withoutbf: this.state.selectedCheckBoxes?.breakfast?.[1]
    //         ? this.state.selectedCheckBoxes?.breakfast?.[1]
    //         : null,
    //       rf: this.state.selectedCheckBoxes?.room_type?.[0]
    //         ? this.state.selectedCheckBoxes?.room_type?.[0]
    //         : null,
    //       nonrf: this.state.selectedCheckBoxes?.room_type?.[1]
    //         ? this.state.selectedCheckBoxes?.room_type?.[1]
    //         : null,
    //       nationality: this.state.nationallitySearch,
    //       guestId: this.state.guest_id,
    //       is_web_app: false,
    //       hotelLocation: this.state.hotelName,
    //       bookingType:
    //         this.props.isSRP === true
    //           ? this.props?.bookingType
    //           : bookingType[0]?.tripId,
    //       guestCheck: this.state.isguestChecked,
    //       employeeGuest: this.state?.employeeguestId,
    //       isModifySearch: this.props.isModifySearch || false,
    //     };

    //     console.log(urlQuery, "urlQuery")
    //     console.log("after this.state.selectedCheckBoxes=>", this.state.selectedCheckBoxes);
    //     localStorage.setItem("hotel_srp", JSON.stringify(urlQuery));
    //     // if (this.props.isOffline === false) {
    //     //   console.log("inside redirect=>");
    //     //   cf.redirectTo("/hotel/search", urlQuery);
    //     // } else if (this.props.isOffline === true) {
    //     //   const searchParams = new URLSearchParams(urlQuery);
    //     //   const queryString = searchParams.toString();
    //     //   window.location = "/offlinesearch/hotel?" + queryString;
    //     // }
    //   }
    // });
  };

  onClickSetHotelName = (element) => {
    // this.setState({ isError: mapDispatch }, () => {})
    // console.log("setHotelName", element)
    if (element.search_text) {
      if (this.state.isError.hotelName === true) {
        this.state.isError.hotelName = false;
      }
    }

    this.setState({
      hotelName: element.search_text,
      getDestinationId: element.destination_id,
      getSearchType: element.search_type ? element.search_type : 6,
      selectedHotel: element,
    });
  };
  getCheckInOutValue = (checkIn, checkOut) => {
    let checkInArr = checkIn.split("/");
    let checkOutArr = checkOut.split("/");
    return checkIn + " - " + checkOut;
  };
  onClickVisibilityStatus = (type, value) => {
    this.setState({ openTraveler: false });
    this.setScrollDown.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    switch (type) {
      case "hotel":
        this.props.expandHotelNameBooleanfunc(value);
        if (
          this.state.expandCheckInOutDateBoolean === true ||
          this.state.openRoomDetailList === true
        ) {
          this.setState({
            expandCheckInOutDateBoolean: false,
            openRoomDetailList: false,
          });
        }
        break;
      case "calendar":
        this.setState({ expandCheckInOutDateBoolean: value }, () => {
          if (
            this.props.expandHotelNameBoolean === true ||
            this.state.openRoomDetailList === true
          ) {
            this.setState({ openRoomDetailList: false });
            this.props.expandHotelNameBooleanfunc(false);
          }
        });
        break;
      case "rooms":
        if (this.state.openRoomDetailList === false) {
          this.setState({ openRoomDetailList: true }, () => {
            if (
              this.props.expandHotelNameBoolean === true ||
              this.state.expandCheckInOutDateBoolean === true
            ) {
              this.setState({ expandCheckInOutDateBoolean: false });
              this.props.expandHotelNameBooleanfunc(false);
            }
          });
        } else {
          this.onClickDoneButton();
        }
        break;
      default:
        break;
    }
  };
  onClickHotelInput = () => {
    this.props.getAutoSuggestValue("");
  };
  renderInfo = () => {
    this.props.getAutoSuggestValue(regions);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      regions != null &&
      regions != "" &&
      regions != undefined &&
      !this.props.isSRP
    ) {
      if (
        prevProps.getAutoSuggestList.length <
        this.props.getAutoSuggestList.length
      ) {
        prevProps.getAutoSuggestList = this.props.getAutoSuggestList;
        this.setState(
          {
            hotelName: prevProps.getAutoSuggestList[0].search_text,
            getDestinationId: prevProps.getAutoSuggestList[0].destination_id,
            getSearchType: prevProps.getAutoSuggestList[0].search_type,
            userProfileId: prevProps.userProfile,
          },
          () => {
            this.props.expandHotelNameBooleanfunc(false);
          }
        );
      }
    }
  }

  onInputFocus = (fieldName) => {
    if (fieldName == "autocomplete") {
      this.onClickVisibilityStatus("hotel", true);
    }
    if (fieldName == "calendar") {
      this.onClickVisibilityStatus("calendar", true);
    }
    if (fieldName == "rooms") {
      this.onClickVisibilityStatus("rooms");
      this.setState({
        openRoomDetailList: this.state.openRoomDetailList,
      });
    }
  };

  highlightData(id, parentElement) {
    let innerContent = document.getElementById(parentElement).children;
    for (let i = 0; i < innerContent.length; i++) {
      let selectedElement = innerContent[i];
      if (i == id) {
        selectedElement.classList.add("ActiveKeyPress");
      } else {
        selectedElement.classList.remove("ActiveKeyPress");
      }
    }

    innerContent[id].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }
  onKeyDownArrow = (event, parentClassId, moduleType) => {
    switch (event.which) {
      case 38: // up
        indexDropdown--;
        if (indexDropdown < 0) {
          indexDropdown = 0;
        }
        this.highlightData(indexDropdown, parentClassId);
        search_text =
          this.props.getAutoSuggestList.length >= indexDropdown
            ? `${this.props.getAutoSuggestList[indexDropdown].search_text}`
            : "";
        destination_id =
          this.props.getAutoSuggestList.length >= indexDropdown
            ? `${this.props.getAutoSuggestList[indexDropdown].destination_id}`
            : "";
        search_type =
          this.props.getAutoSuggestList.length >= indexDropdown
            ? `${
                this.props.getAutoSuggestList[indexDropdown].search_type
                  ? this.props.getAutoSuggestList[indexDropdown].search_type
                  : 1
              }`
            : "";
        break;
      case 40: // down
        indexDropdown++;
        if (indexDropdown > this.props.getAutoSuggestList.length - 1) {
          indexDropdown = 0;
        }
        this.highlightData(indexDropdown, parentClassId);
        search_text =
          this.props.getAutoSuggestList.length >= indexDropdown
            ? `${this.props.getAutoSuggestList[indexDropdown].search_text}`
            : "";
        destination_id =
          this.props.getAutoSuggestList.length >= indexDropdown
            ? `${this.props.getAutoSuggestList[indexDropdown].destination_id}`
            : "";
        search_type =
          this.props.getAutoSuggestList.length >= indexDropdown
            ? `${
                this.props.getAutoSuggestList[indexDropdown].search_type
                  ? this.props.getAutoSuggestList[indexDropdown].search_type
                  : 1
              }`
            : "";
        break;

      case 13: //enter
        this.setState(
          {
            hotelName: search_text,
            getDestinationId: destination_id,
            getSearchType: search_type,
          },
          () => {
            this.onClickVisibilityStatus("hotel", false);
          }
        );
        indexDropdown = -1;
        break;
      case 9: //tab
        this.setState(
          {
            hotelName: search_text,
            getDestinationId: destination_id,
            getSearchType: search_type,
          },
          () => {
            this.onClickVisibilityStatus("hotel", false);
          }
        );
        indexDropdown = -1;

        break;
      default:
    }
  };
  focusOutDone = () => {
    /*this.onClickVisibilityStatus("rooms", false) */
    this.setState({
      openRoomDetailList: this.state.openRoomDetailList,
    });
    console.log("focus out done");
  };
  onClickTraveller = () => {
    this.setState({ advSearch: false });
    if (!this.state.openTraveler) {
      this.setState({ openTraveler: true });
    } else {
      this.setState({ openTraveler: false });
    }
  };

  onClickAdvSearch = () => {
    this.setState({ openTraveler: false });
    if (!this.state.advSearch) {
      this.setState({ advSearch: true });
    } else {
      this.setState({ advSearch: false });
    }
  };

  onClickNationality = () => {
    if (!this.state.nationallitySearch) {
      this.setState({ nationallitySearch: true });
    } else {
      this.setState({ nationallitySearch: false });
    }
  };

  onTickAdvSearch = () => {
    cf.redirectTo("/hotel/search", urlQuery);
  };

  applyb2bFilters = (filterName, event, checkbox, index) => {
    console.log("filterName, event", filterName, event);

    switch (filterName) {
      case "star":
        const { value, checked } = event.target;
        if (checked && !this.state.response.includes(value)) {
          this.setState({ response: [...this.state.response, value] });
        } else {
          this.setState({
            response: this.state.response.filter((val) => {
              return val !== value;
            }),
          });
        }
        break;
      default:
        break;
    }
  };

  handleStarCheck = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  selectNationality = (params) => {
    this.setState({ selectedNationality: params });
    this.setState({ nationallitySearch: params.countryCode });
  };

  onChangeNationalityCode = (params) => {
    console.log("params==>", params);
    this.setState({ selectedNationality: { flag: "/images/ax-tick.svg" } });
  };

  // Country of Residence handlers
  selectCountryOfResidence = (params) => {
    this.setState({
      countryOfResidence: params,
      isError: {
        ...this.state.isError,
        countryOfResidence: false,
      },
    });
  };

  onChangeCountryOfResidenceCode = (e) => {
    const value = typeof e === "string" ? e : e?.target?.value || "";
    this.setState({
      countryOfResidence: {
        value: value,
        label: "",
        flag: "",
        countryCode: "",
      },
    });
  };

  // handleCheckboxSelection = (event, index) => {
  //   console.log("handleCheckboxSelection",event, index)

  //   let updatedSelections = new Array(index + 1).fill(false);
  //     updatedSelections[index] = event.target.checked;

  //     this.setState((prev) => ({
  //       selectedCheckBoxes: {
  //         ...prev.selectedCheckBoxes,
  //         [event.target.name]: updatedSelections,
  //       },
  //     }));

  // };
  handleCheckboxSelection = (event, index) => {
    // Destructure properties from the event object
    const { name, checked } = event.target;
    console.log("name=>", name, "checked=>", checked);

    // Use the `setState` function to update the component's state
    this.setState((prev) => {
      // Get the current selection array for the checkbox by its name
      const currentSelection = prev.selectedCheckBoxes[name] || [];

      // Create a copy of the current selection array
      const updatedSelections = [...currentSelection];

      // Update the value at the specified index in the array
      updatedSelections[index] = checked;
      console.log("updatedSelections=>", updatedSelections);
      // Return the updated state object
      return {
        selectedCheckBoxes: {
          ...prev.selectedCheckBoxes,
          [name]: updatedSelections,
        },
      };
    });
  };

  colleguesPolicy = (corporate_detail, selectedtrip) => {
    let bookingType = selectedtrip.filter((res) => res.selected);
    let newBookingType = [];
    newBookingType.push(corporate_detail?.et_details?.annual);
    newBookingType.push(corporate_detail?.et_details?.business);
    newBookingType.push(corporate_detail?.et_details?.exceptional);
    newBookingType.push(corporate_detail?.et_details?.personal);

    let bookingobj = newBookingType.filter(
      (res) => res?.id === Number(bookingType?.[0]?.tripId)
    );
    this.setState({
      etPolicy: bookingobj?.[0]?.policy_applicable == "yes" ? true : false,
    });
  };

  adGuestId = (id, corporate_detail) => {
    this.colleguesPolicy(corporate_detail, this.state.bookingType);

    this.setState({ guest_id: id }, () => {
      if (this.state.isError.selectedGuest === true) {
        // this.validateErrorMsg();
      }
      this.setState({
        guest_id: id,
        isError: { ...this.state.isError, colleagueError: false },
        colleagueEtRule: corporate_detail,
      });
    });
  };

  guestDetail = (guestdetail) => {
    console.log("guestDetail-------------", guestdetail);
    console.log("bookingType===========", this?.props?.userProfile);
    if (guestdetail[0]?.corporate_detail?.et_details?.annual?.status) {
      this.state.guestBookingType.find(
        (item) => item.name === "annual"
      ).show = true;
    } else {
      this.state.guestBookingType.find(
        (item) => item.name === "annual"
      ).show = false;
    }
    if (guestdetail[0]?.corporate_detail?.et_details?.business?.status) {
      this.state.guestBookingType.find(
        (item) => item.name === "business"
      ).show = true;
    } else {
      this.state.guestBookingType.find(
        (item) => item.name === "business"
      ).show = false;
    }
    if (guestdetail[0]?.corporate_detail?.et_details?.personal?.status) {
      this.state.guestBookingType.find(
        (item) => item.name === "personal"
      ).show = true;
    } else {
      this.state.guestBookingType.find(
        (item) => item.name === "personal"
      ).show = false;
    }
    if (guestdetail[0]?.corporate_detail?.et_details?.exceptional?.status) {
      this.state.guestBookingType.find(
        (item) => item.name === "exceptional"
      ).show = true;
    } else {
      this.state.guestBookingType.find(
        (item) => item.name === "exceptional"
      ).show = false;
    }
    let filterTrip = this.state.guestBookingType.filter((item) => item.show);
    console.log("filterTrip==================", this.state.guestBookingType);
    if (this.state.guestBookingType.length > 0) {
      let index = 0;
      let new_data = this.state.guestBookingType.map((res, i) => {
        if (res.show && index < 1) {
          index = index + 1;
          return {
            ...res,
            selected: true,
          };
        } else {
          return {
            ...res,
            selected: false,
          };
        }
      });
      this.setState({
        guestBookingType: new_data,
        // bookingTypeId: new_data[0].tripId,
      });
      console.log("new_data============", new_data);
    }
  };

  rmGuestId = () => {
    this.setState({ guest_id: "" });
    // this.bookingTypeComp();
  };

  bookingTypeComp = () => {
    checksession()
      .then((response) => {
        // console.log("hotel response---------", response);
        if (response.status) {
          let corporate_detail = response?.corporate_detail;
          if (corporate_detail?.et_details?.annual?.status) {
            this.state.bookingType.find(
              (item) => item.name === "annual"
            ).show = true;
          } else {
            this.state.bookingType.find(
              (item) => item.name === "annual"
            ).show = false;
          }
          if (corporate_detail?.et_details?.business?.status) {
            this.state.bookingType.find(
              (item) => item.name === "business"
            ).show = true;
          } else {
            this.state.bookingType.find(
              (item) => item.name === "business"
            ).show = false;
          }
          if (corporate_detail?.et_details?.personal?.status) {
            this.state.bookingType.find(
              (item) => item.name === "personal"
            ).show = true;
          } else {
            this.state.bookingType.find(
              (item) => item.name === "personal"
            ).show = false;
          }
          if (corporate_detail?.et_details?.exceptional?.status) {
            this.state.bookingType.find(
              (item) => item.name === "exceptional"
            ).show = true;
          } else {
            this.state.bookingType.find(
              (item) => item.name === "exceptional"
            ).show = false;
          }

          let filterTrip = this.state.bookingType.filter((item) => item.show);
          console.log("filterTrip==================", this.state.bookingType);
          if (this.state.bookingType.length > 0 && !this.props.isSRP) {
            let index = 0;
            let new_data = this.state.bookingType.map((res, i) => {
              if (res.show && index < 1) {
                index = index + 1;
                return {
                  ...res,
                  selected: true,
                };
              } else {
                return {
                  ...res,
                  selected: false,
                };
              }
            });
            this.setState({
              bookingType: new_data,
              bookingTypeId: new_data[0].tripId,
            });
          }
          if (this.state.guest_id === "" && response?.user_type === "CT") {
            this.setState({ guest_id: response?._id });
          }
          if (
            this.state.employeeguestId.length === 0 &&
            response?.user_type === "CT" &&
            !this.props.isSRP
          ) {
            this.setState({ employeeguestId: [response?._id] });
          }
          if (
            !this.props.isSRP &&
            response?.type == "B2E" &&
            response?.user_type === "CT"
          ) {
            let nationalityList = {
              value: response?.nationality?.name
                ? response?.nationality?.name
                : "",
              countryCode: response?.nationality?.code,
            };
            this.setState({ selectedNationality: nationalityList });
            this.setState({ nationallitySearch: nationalityList?.countryCode });
          }
        }
      })
      .catch((err) => {
        console.log(err.msg);
      });
  };

  // Add Colleague

  addEmployeeGuestId = (item) => {
    console.log("item", this.props.userProfile._id);
    this.setState((prevState) => ({
      employeeguestId: [...prevState.employeeguestId, item],
    }));
  };

  removeEmployeeGuestId = (updatedId) => {
    this.setState({ employeeguestId: updatedId, colleagueEtRule: {} });
  };

  onClickStarSearch = () => {
    this.setState({ openTraveler: false });
    if (!this.state.showStarSearch) {
      this.setState({ showStarSearch: true });
    } else {
      this.setState({ showStarSearch: false });
    }
  };

  onClickRoomTypeSearch = () => {
    if (!this.state.showRoomTypeSeach) {
      this.setState({ showRoomTypeSeach: true });
    } else {
      this.setState({ showRoomTypeSeach: false });
    }
  };

  onClickBreakfastSearch = () => {
    if (!this.state.showBreakfastSearch) {
      this.setState({ showBreakfastSearch: true });
    } else {
      this.setState({ showBreakfastSearch: false });
    }
  };

  onClickClientNationality = (nationality, id, email, isAdd) => {
    console.log("params", id, email);
    console.log("isAdd", isAdd);
    console.log("nationality", nationality);
    if (isAdd) {
      let nationalityList = {
        value: nationality == null ? "" : nationality,
        countryCode: "",
      };
      this.setState({ selectedNationality: nationalityList });
      this.setState({ clientNationality: nationalityList });
    } else {
      let nationalityList = { value: "", countryCode: "" };
      this.setState({ selectedNationality: nationalityList });
      this.setState({ clientNationality: nationalityList });
    }
  };

  bookingTypeMethod = (id) => {
    console.log("id=====>", id);
    let bookingType = this.state.bookingType;
    let newdata = bookingType.map((res, ind) => {
      if (res.tripId === id) {
        this.setState({ bookingTypeId: id });
        return {
          ...res,
          selected: true,
        };
      } else {
        return {
          ...res,
          selected: false,
        };
      }
    });

    if (this.props.isSRP) {
      this.setState({
        bookingType: newdata,
        bookingTypeId: newdata[0].tripId,
      });
    } else {
      this.setState({
        bookingType: newdata,
        isguestChecked: false,
      });
    }
    this.colleguesPolicy(this.state.colleagueEtRule, newdata);

    // console.log("ypemount,fact,id", typemount, fact, id, bookingType, newdata);
  };

  handleGuestCheckbox = () => {
    this.setState(
      {
        isguestChecked: !this.state.isguestChecked,
        isError: { ...this.state.isError, colleagueError: false }, // Update the nested state property
      },
      () => {
        // Optional callback function after state is updated
      }
    );
    // this.bookingTypeComp();
  };

  shouldShowChildOption() {
    if (this.props.isSRP) {
      return !(
        this.props.query.bookingType === "1" ||
        this.props.query.bookingType === "4"
      );
    } else {
      // Replace this with your actual condition based on "business and exceptional" type
      return (
        !this.state.bookingType[0]?.selected &&
        !this.state.bookingType[3]?.selected
      );
    }
  }
  modalPopupSwitch = () => {
    switch (this.state.modalPopupValue) {
      case "etRule":
        return (
          <div className={this.props.styles.enquiy_container}>
            <div className={this.props.styles.send_success}></div>
            <div className={this.props.styles.enquire_wrap}>
              <span className={this.props.styles.quote_lblTitle}></span>
            </div>
            <span className={this.props.styles.quote_success}>
              Selected Trip Type is not allowed as per Employee policy
            </span>
            <div className={this.props.styles.btn_container}>
              <button
                className={this.props.styles.ok_button}
                onClick={() => {
                  // this.onButtonEnquiry()
                  this.setState({
                    showbookingTypeError: false,
                  });
                }}
              >
                OK
              </button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  countryClickHandler = (e) => {
    // this.setState({ pickuploc: e.value, isError[hotelName]: false });
    this.setState((prevState) => ({
      pickuploc: e.value,
      isError: {
        ...prevState.isError,
        hotelName: false,
      },
    }));
    this.setState({ SelectedCountry: e });
    this.setState({ countryCode: e.value });
    this.setState({ selectedCountryLocation: e.countryName });
    console.log("ddd", e);
  };
  countryChangeHandler = (e) => {
    this.setState({ countryCode: e.target.value });
    // this.setState({ pickuploc: e.target.value, isError[hotelName]: false });
    this.setState((prevState) => ({
      pickuploc: e.target.value,
      isError: {
        ...prevState.isError,
        hotelName: false,
      },
    }));
    this.setState({ SelectedCountry: { flag: "/images/user-active.png" } });
    this.setState({ countryCode: e.target.value });
    // for Hotel Namechange handler
    const countryFlag1 = this.state.countryList.filter((ele) =>
      ele.value.includes(e.target.value)
    );
    if (countryFlag1.length === 0) {
      this.setState((prevState) => ({
        selectedHotelAddress: e.target.value,
        isError: {
          ...prevState.isError,
          hotelName: false,
        },
      }));
      this.setState({ pickuploc: "" });
      this.setState({ selectedCountryLocation: "" });
    }
  };

  render() {
    // console.log("this.state.selectedNationality",this.state.selectedNationality)
    console.log("this.state.clientNationality", this.state.bookingType);
    return (
      <>
        <div
          ref={this.setScrollDown}
          className={`${
            !this.props.isSRP ? "container mx-auto xl:px-8" : "container "
          } ${this.props.isMobile ? this.props.styles.hotel_mobileWrap : ""}
          ${this.props?.isOffline ? this.props.styles.Offlinewidgethotel : ""}
          `}
        >
          {this.props?.isMobile && (
            <div className={this.props.styles.mobile_header}>
              <div className={this.props.styles.mobile_visible}>
                <div
                  className={
                    this.props.styles.mobo_tab_header +
                    " " +
                    this.props.styles.flight_header_mobo
                  }
                >
                  {this.props.isSRP ? (
                    <img
                      src="/images/blue-backarrow.svg"
                      alt=""
                      className={this.props.styles.arrow_image}
                      onClick={() => this.props.onClosePopup(false)}
                    />
                  ) : (
                    <img
                      src="/images/blue-backarrow.svg"
                      alt=""
                      className={this.props.styles.arrow_image}
                      onClick={() => this.props.onClosePopup(false)}
                    />
                  )}
                  <h3 className={this.props.styles.search_filter_header}>
                    {" "}
                    {this.props.isSRP ? "Modify search" : "Hotel"}
                  </h3>
                </div>
              </div>
            </div>
          )}
          <div className={this.props.styles.hotel_search_wid_container}>
            <div className={this.props.styles.hotel_search_wid_main}>
              {/* {!this.props.isSRP ? (
              <div className={this.props.styles.hotel_way_title}>
                <svg width="40px" height="40px" viewBox="0 0 200 200">
                  <g id="Layer_2">
                    <path
                      fill="#30C8CA"
                      d="M166.2,75.467c0-15.693-12.841-28.533-28.534-28.533H66.333c-15.693,0-28.533,12.84-28.533,28.533v27.106   c-4.28,3.567-7.133,9.273-7.133,15.693v19.261v2.14v14.267c0,4.28,2.854,7.133,7.133,7.133c4.28,0,7.133-2.853,7.133-7.133V146.8   h114.133v7.134c0,4.28,2.854,7.133,7.134,7.133c4.279,0,7.133-2.853,7.133-7.133v-14.267v-2.14v-19.261   c0-6.42-2.854-12.126-7.133-15.693V75.467z M52.066,75.467c0-7.847,6.42-14.267,14.267-14.267h71.333   c7.847,0,14.267,6.42,14.267,14.267v21.4H144.8v-7.134c0-12.126-9.273-21.4-21.4-21.4h-7.133c-5.707,0-10.7,2.14-14.267,5.707   c-3.567-3.566-8.561-5.707-14.267-5.707H80.6c-12.126,0-21.4,9.273-21.4,21.4v7.134h-7.133V75.467z M130.533,89.733v7.134h-21.4   v-7.134c0-4.28,2.854-7.133,7.134-7.133h7.133C127.68,82.6,130.533,85.454,130.533,89.733z M94.866,89.733v7.134h-21.4v-7.134   c0-4.28,2.854-7.133,7.133-7.133h7.133C92.013,82.6,94.866,85.454,94.866,89.733z M159.066,132.533H44.933v-14.267   c0-4.279,2.854-7.133,7.133-7.133h21.4h21.4h14.267h21.4h21.399c4.28,0,7.134,2.854,7.134,7.133V132.533z"
                    />
                  </g>
                </svg>
                Hotels
              </div>
            ) : null} */}

              {!this.props.isSRP && this.props?.userProfile?.type === "B2E" && (
                <div className={this.props.styles.hotelTrip}>
                  <div>Trip Type :</div>
                  {this.state.bookingType.length > 0 &&
                    this.state.bookingType.map((trip, id) => {
                      return (
                        trip.show && (
                          <div>
                            <input
                              type="radio"
                              id={trip.value}
                              value={trip.value}
                              checked={trip.selected}
                              onChange={() => {
                                this.bookingTypeMethod(trip.tripId);
                              }}
                            />
                            <label htmlFor={trip.value}>{trip.label}</label>
                          </div>
                        )
                      );
                    })}
                </div>
              )}

              {!this.props.isSRP && this.props?.offlineType !== "Enquiry" ? (
                <div className={this.props.styles.hotelNationBtob}>
                  {this.props?.offlineType !== "Enquiry" ||
                  !this.props.isSRP ? (
                    <div>
                      <NationalityDropdownComp
                        theme="theme4"
                        countryFlag={this.state.originCountries}
                        searchText={
                          this.state.clientNationality.value == ("" || null)
                            ? ""
                            : this.state.clientNationality.value
                        }
                        selectNationality={this.selectNationality}
                        selectedNationality={this.state.selectedNationality}
                        onChangeNationalityCode={this.onChangeNationalityCode}
                        placeholder={"Select Nationality"}
                        // placeholder={this.state.clientNationality == ("" || undefined) ?"Select Nationality":this.state.clientNationality}
                        isSignUpNationality={false}
                        isB2B={true}
                        errorMessage={
                          this.state.selectedNationality.value == "" ||
                          this.state.selectedNationality?.flag
                            ? "Select Nationality"
                            : ""
                        }
                        isError={
                          this.state.selectedNationality.value == "" ||
                          this.state.clientNationality?.value == ""
                            ? this.state.isError.selectedNationality
                            : ""
                        }
                        styles={this.props.styles}
                        {...this.props.Countrystyles}
                        // {...this.props.data.Countrystyles}
                      />
                    </div>
                  ) : null}

                  {/* Country of Residence */}
                  {this.props?.offlineType !== "Enquiry" || !this.props.isSRP ? (
                    <div className={this.props.styles.countryResidence}>
                      <NationalityDropdownComp
                        theme="theme4"
                        countryFlag={this.state.countriesResidenceList}
                        searchText={
                          this.state.countryOfResidence.value === ("" || null)
                            ? ""
                            : this.state.countryOfResidence.value
                        }
                        selectNationality={this.selectCountryOfResidence}
                        selectedNationality={this.state.countryOfResidence}
                        onChangeNationalityCode={this.onChangeCountryOfResidenceCode}
                        placeholder={"Select Country of Residence"}
                        isSignUpNationality={false}
                        isB2B={true}
                        errorMessage={"Select Country of Residence"}
                        isError={this.state.isError.countryOfResidence}
                        styles={this.props.styles}
                        {...this.props.Countrystyles}
                      />
                    </div>
                  ) : null}

                  {this.props?.offlineType !== "Enquiry" ||
                  !this.props.isSRP ? (
                    <B2BWidgets
                      {...this.state}
                      theme="theme4"
                      styles={this.props.b2bStyles}
                      onClickTraveller={this.onClickTraveller}
                      onClickAdvSearch={this.onClickAdvSearch}
                      onClickSearchHotel={this.onClickSearchHotel}
                      onTickAdvSearch={this.onTickAdvSearch}
                      onClickNationality={this.onClickNationality}
                      applyb2bFilters={this.applyb2bFilters}
                      handleCheckboxSelection={this.handleCheckboxSelection}
                      selectedCheckBoxes={this.state.selectedCheckBoxes}
                      handleStarCheck={this.handleStarCheck}
                      isOneStar={this.state.isOneStar}
                      isTwoStar={this.state.isTwoStar}
                      isThreeStar={this.state.isThreeStar}
                      isFourStar={this.state.isFourStar}
                      isFiveStar={this.state.isFiveStar}
                      addGuestId={this.adGuestId}
                      guestDetail={this.guestDetail}
                      removeGuestId={this.rmGuestId}
                      listWrapper={this.advanceSearchWrapper}
                      guestWrapper={this.guestDetailWrapper}
                      isOffline={this.props.isOffline}
                      errorMessage={
                        this.props.isOffline && this.state.guest_id == ""
                          ? "Select Traveler"
                          : ""
                      }
                      isError={this.state.isError.selectedGuest}
                      clientNationality={this.onClickClientNationality}
                      userProfile={this?.props?.userProfile}
                      handleGuestCheckbox={this.handleGuestCheckbox}
                      isguestChecked={this.state.isguestChecked}
                      addEmployeeGuestId={this.addEmployeeGuestId}
                      removeEmployeeGuestId={this.removeEmployeeGuestId}
                      totalPax={this.state.selectedRoomDetails.rooms}
                      bookingTypeId={
                        this.state?.bookingType?.find((trip) => trip?.selected)
                          ?.tripId
                      }
                    />
                  ) : null}
                </div>
              ) : null}
              {!this.props.isSRP && (
                <div
                  className={this.props.styles?.hotel_colleague_error_message}
                >
                  <span className={this.props.styles?.red_text}>
                    {this.state.isError.colleagueError &&
                    this.props.userProfile.type === "B2E" &&
                    (this.props?.userProfile?.user_type === "TD" ||
                      this.props?.userProfile?.user_type === "ADMIN") &&
                    !this.state.isguestChecked
                      ? "Please Select Atleast One Colleague"
                      : this.state.isError.colleagueError
                      ? "Please Add Colleague"
                      : ""}
                  </span>
                </div>
              )}
              <div
                className={`${
                  this.props.styles.hotel_search_details_container
                } ${
                  !this.props.isSRP
                    ? this.props.styles.home_bgcolor
                    : this.props.styles.srp_bgcolor
                }`}
              >
                <div className={this.props.styles.hotel_search_details_main}>
                  <div
                    className={`${this.props.styles.hotel_search_details_row} ${this.props.styles.mod_search_flx}`}
                    ref={this.setDropdownWrapperRef}
                  >
                    {this.props?.offlineType !== "Enquiry" && (
                      <div
                        id="hotelList"
                        className={`${this.props.styles.hotel_search_column} ${
                          this.props.styles.hotel_search_name
                        } ${
                          this.props.isSRP
                            ? this.props.styles.srp_hotel_search_name
                            : ""
                        }`}
                      >
                        <HotelAutoComplete
                          tabIndex={1}
                          isDisable={this.props.isDisable === true}
                          label={
                            this.props.isOffline
                              ? "Destination"
                              : "Destination or Hotel Name"
                          }
                          styles={this.props.styles}
                          value={this.state.hotelName}
                          onKeyDownArrow={(event) => {
                            this.onKeyDownArrow(
                              event,
                              "hotelDataArray",
                              "hotel"
                            );
                          }}
                          placholder={
                            this.props.isOffline
                              ? "Select Country"
                              : "Where are you going?"
                          }
                          onInputFocus={() => {
                            this.onInputFocus("autocomplete");
                          }}
                          onClickHotelInput={() => this.onClickHotelInput()}
                          onClickHotelName={(value) =>
                            this.onClickSetHotelName(value)
                          }
                          onChangeHotelName={(value) =>
                            this.onChangeSetHotelName(value)
                          }
                          isAutoCompleteExpand={(value) =>
                            this.onClickVisibilityStatus("hotel", value)
                          }
                          autoCompleteData={
                            !cf.isValueEmpty(this.props.getAutoSuggestList)
                              ? this.props.getAutoSuggestList
                              : []
                          }
                          expandAutoCompleteBool={
                            !cf.isValueEmpty(this.props.expandHotelNameBoolean)
                              ? this.props.expandHotelNameBoolean
                              : false
                          }
                          leftIcon={
                            this.props.isSRP ? (
                              ""
                            ) : (
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17"
                                  height="19"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="M9.33 18.152c-.39.042-.49.063-.589.063a.707.707 0 0 1-.292-.063C3.569 15.937.656 12.24.656 8.26.656 3.791 4.283.155 8.741.155c4.458 0 8.084 3.636 8.084 8.105 0 3.98-2.913 7.677-7.495 9.892zM8.741 1.574c-3.111 0-6.021 3-6.021 6.686 0 3.33 1.838 6.476 6.021 8.463 4.183-1.987 6.669-5.133 6.669-8.463 0-3.686-2.992-6.686-6.669-6.686zm0 10.17A3.483 3.483 0 0 1 5.267 8.26a3.483 3.483 0 0 1 3.474-3.483 3.483 3.483 0 0 1 0 6.967zm0-5.547a2.063 2.063 0 0 0 0 4.127 2.063 2.063 0 0 0 0-4.127z"
                                  ></path>
                                </svg>
                              </span>
                            )
                          }
                          errorMessage={
                            this.state.isError.hotelName
                              ? ""
                              : "Enter Destination"
                          }
                          isError={this.state.isError.hotelName}
                          isSrp={this.props.isSRP}
                        />
                      </div>
                    )}
                    {this.props?.offlineType == "Enquiry" &&
                      !this.props.isSRP && (
                        <>
                          <div
                            id="hotelList"
                            className={`${
                              this.props.styles.hotel_search_column
                            } ${this.props.styles.hotel_search_name} ${
                              this.props.isSRP
                                ? this.props.styles.srp_hotel_search_name
                                : ""
                            }`}
                          >
                            <label>Destination</label>
                            <div className={this.props.styles.cityname_flex}>
                              <div
                                className={
                                  this.props.styles.hotel_search_left_icon
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17"
                                  height="19"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="M9.33 18.152c-.39.042-.49.063-.589.063a.707.707 0 0 1-.292-.063C3.569 15.937.656 12.24.656 8.26.656 3.791 4.283.155 8.741.155c4.458 0 8.084 3.636 8.084 8.105 0 3.98-2.913 7.677-7.495 9.892zM8.741 1.574c-3.111 0-6.021 3-6.021 6.686 0 3.33 1.838 6.476 6.021 8.463 4.183-1.987 6.669-5.133 6.669-8.463 0-3.686-2.992-6.686-6.669-6.686zm0 10.17A3.483 3.483 0 0 1 5.267 8.26a3.483 3.483 0 0 1 3.474-3.483 3.483 3.483 0 0 1 0 6.967zm0-5.547a2.063 2.063 0 0 0 0 4.127 2.063 2.063 0 0 0 0-4.127z"
                                  />
                                </svg>
                              </div>

                              <CountryDropdownComp
                                countryFlag={
                                  this.state.countryList
                                    ? this.state.countryList
                                    : []
                                }
                                label={"Destination"}
                                searchText={this.state.countryCode}
                                selectCountry={this.countryClickHandler}
                                selectedCountry={this.state.selectedCountry}
                                onChangeInputCountryCode={
                                  this.countryChangeHandler
                                }
                                placeholder={"Select City"}
                                style={this.props.styles}
                                theme={"theme4"}
                                {...this.props.Countrystyles}
                              />
                            </div>
                            {this.state.isError.hotelName && (
                              <div
                                className={
                                  this.props.styles.hotel_search_error_message
                                }
                              >
                                {"Enter Origin city"}
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    <div
                      className={`${this.props.styles.hotel_search_column} ${
                        this.props.styles.hotel_search_date
                      } ${
                        this.props.isSRP
                          ? this.props.styles.srp_hotel_search_date
                          : ""
                      }`}
                    >
                      {this.props.isMobile ? (
                        <MobileCalender
                          // label="Check In & Check Out Date"
                          styles={this.props.styles}
                          value={
                            !cf.isValueEmpty(this.state.checkInOutValue)
                              ? this.state.checkInOutValue
                              : ""
                          }
                          placholder="Select the date"
                          onChangeDate={(type, value) => {
                            this.onChangeCheckInOutValue(type, value);
                          }}
                          iconImage="/images/cyan-calendar.svg"
                          startDate={
                            !cf.isValueEmpty(this.state.checkInValue)
                              ? new Date(this.state.checkInValue) // original >>> this.state.checkInValue
                              : ""
                          }
                          endDate={
                            !cf.isValueEmpty(this.state.checkOutValue)
                              ? new Date(this.state.checkOutValue) // original >>> this.state.checkOutValue
                              : ""
                          }
                          startDateLimit={
                            !cf.isValueEmpty(this.state.dateLimit)
                              ? new Date(this.state.dateLimit) // original >>> this.state.dateLimit
                              : ""
                          }
                          dateFormat={"DD-MMM-YYYY"}
                          changeVisibility={(bool) =>
                            this.onClickVisibilityStatus("calendar", bool)
                          }
                          isVisible={this.state.expandCheckInOutDateBoolean}
                          type={"double"}
                          doubleSelection={true}
                          totalMonths={12}
                          serviceType="hotel"
                        />
                      ) : (
                        <DesktopCalender
                          // tabIndex={2}
                          label="Check In & Check Out Date"
                          styles={this.props.styles}
                          value={
                            !cf.isValueEmpty(this.state.checkInOutValue)
                              ? this.state.checkInOutValue
                              : ""
                          }
                          placholder="Select the date"
                          onChangeDate={(type, value) => {
                            this.onChangeCheckInOutValue(type, value);
                          }}
                          onInputFocus={() => {
                            this.onInputFocus("calendar");
                          }}
                          iconImage={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="19"
                              height="19"
                            >
                              <path
                                fill-rule="evenodd"
                                fill="#01445F"
                                d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.85V3.148c0 .162-.49-.224-.892-.303a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.589.627.966V16.656c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627-.248-.25-.401-.303-.401-.968V3.148c0-.377.153-.718.401-.966.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.303v3.499zm16.922.94H.938v9.068c0 .117.049.224.702.303-.498.402-.391.892-.272.892h15.288c.118 0 .225-.49.304-.892.42-.077.9-.184.9-.303V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                              />
                            </svg>
                          }
                          startDate={
                            !cf.isValueEmpty(this.state.checkInValue)
                              ? this.state.checkInValue
                              : ""
                          }
                          endDate={
                            !cf.isValueEmpty(this.state.checkOutValue)
                              ? this.state.checkOutValue
                              : ""
                          }
                          startDateLimit={
                            !cf.isValueEmpty(this.state.dateLimit)
                              ? this.state.dateLimit
                              : ""
                          }
                          dateFormat={this?.props?.dateFormat}
                          changeVisibility={(bool) =>
                            this.onClickVisibilityStatus("calendar", bool)
                          }
                          isVisible={this.state.expandCheckInOutDateBoolean}
                          type={"double"}
                          doubleSelection={true}
                        />
                      )}
                    </div>
                    <div
                      className={
                        this.props.styles.hotel_search_column +
                        " " +
                        this.props.styles.hotel_search_accomodation
                      }
                    >
                      <div
                        className={this.props.styles.hotel_cabin_class_cont}
                        onClick={() => this.onClickVisibilityStatus("rooms")}
                      >
                        <div
                          className={this.props.styles.hotel_cabin_class_icon}
                        >
                          {/* {this.props.isSRP ? (
                          ""
                        ) : ( */}
                          {/* <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21">
                          <path fill-rule="evenodd" fill="#01445F" d="M10.566 20.332C5.181 20.332.8 15.951.8 10.566S5.181.8 10.566.8s9.766 4.381 9.766 9.766-4.381 9.766-9.766 9.766zm-5.587-3.143a8.629 8.629 0 0 0 5.587 2.046c2.127 0 4.077-.77 5.587-2.046-.209-2.704-3.952-3.002-5.587-3.002-1.635 0-5.378.298-5.587 3.002zm5.587-3.299c3.555 0 5.894.367 7.324 2.379.534-1.525 1.345-3.522 1.345-5.703 0-4.78-3.889-8.669-8.669-8.669-4.78 0-8.669 3.889-8.669 8.669 0 2.181.811 4.178 2.533 5.703.241-2.012 2.68-2.379 6.136-2.379zm0-2.776a3.625 3.625 0 0 1-3.621-3.621 3.625 3.625 0 0 1 3.621-3.621 3.626 3.626 0 0 1 3.621 3.621 3.625 3.625 0 0 1-3.621 3.621zm0-6.144c-1.392 0-2.146 1.132-2.146 2.523 0 1.392.754 2.677 2.146 2.677 1.391 0 3.334-1.285 3.334-2.677 0-1.391-1.943-2.523-3.334-2.523z"/>
                      </svg> */}

                          {/* )} */}
                        </div>

                        <label> Guest(s)</label>

                        <div className={this.props.styles.hotel_guestFlx}>
                          <span>
                            <svg
                              width="15px"
                              height="15px"
                              viewBox="0 0 200 200"
                            >
                              <g>
                                <path
                                  fill="#01445f"
                                  d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                                ></path>
                              </g>
                            </svg>
                          </span>
                          <div
                            className={
                              this.props.styles.hotel_cabin_class_nameNew
                            }
                          >
                            <input
                              tabindex="3"
                              id="hotels_rooms_guests"
                              onFocus={() => {
                                this.onInputFocus("rooms");
                              }}
                              value={
                                !cf.isValueEmpty(this.state.selectedRoomDetails)
                                  ? this.state.selectedRoomDetails.adult +
                                    " Adult, " +
                                    (this.shouldShowChildOption()
                                      ? this.state.selectedRoomDetails.child +
                                        " Child, "
                                      : "") +
                                    this.state.selectedRoomDetails.rooms +
                                    " Room "
                                  : "1 Adult" +
                                    (this.shouldShowChildOption()
                                      ? ", 0 Child"
                                      : "") +
                                    ", 1 Room"
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {this.state.openRoomDetailList === true ? (
                        <div className={this.props.styles.hotel_room_list}>
                          {/* <svg className={this.props.styles.hotel_arrow_pax} width="151" height="101" viewBox="0 0 151 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M75.5 1.3811L140.885 76.0953H10.1151L75.5 1.3811Z" fill="white"/>
                      <line y1="-1.5" x2="100.715" y2="-1.5" transform="matrix(0.666347 -0.745642 0.939264 0.343196 9.5873 76.4784)" stroke="#2FC7C9" stroke-width="3"/>
                      <path d="M76.0269 1.19861L140.214 76.0953" stroke="#2FC7C9" stroke-width="3"/>
                      </svg> */}
                          <div
                            className={this.props.styles.hotel_room_list_main}
                          >
                            <table className={this.props.styles.table_head}>
                              <thead>
                                <tr>
                                  <th>
                                    Rooms <br />
                                    <span
                                      className={
                                        this.props.styles.table_subhead
                                      }
                                    >
                                      {" "}
                                      (Max 4)
                                    </span>
                                  </th>
                                  <th>
                                    Adults
                                    <br />
                                    <span
                                      className={
                                        this.props.styles.table_subhead
                                      }
                                    >
                                      {" "}
                                      (18+ yrs)
                                    </span>
                                  </th>
                                  {this.state.bookingType.length > 0 &&
                                    !this.state.bookingType[0].selected &&
                                    !this.state.bookingType[3].selected && (
                                      <th>
                                        Children <br />
                                        <span
                                          className={
                                            this.props.styles.table_subhead
                                          }
                                        >
                                          {" "}
                                          (1-17 yrs)
                                        </span>
                                      </th>
                                    )}
                                </tr>
                              </thead>
                            </table>
                            {this.state.roomList.map((element, index) => {
                              return (
                                <div
                                  className={
                                    this.props.styles.hotel_room_detail_ele
                                  }
                                  key={index}
                                >
                                  <table
                                    className={this.props.styles.table_body}
                                  >
                                    <tbody>
                                      <tr>
                                        <td>
                                          <div style={{ display: "flex" }}>
                                            {index > 0 ? (
                                              <div
                                                className={
                                                  this.props.styles
                                                    .hotel_room_remove
                                                }
                                                onClick={() =>
                                                  this.removeRoomItem(
                                                    element.id
                                                  )
                                                }
                                              >
                                                X
                                              </div>
                                            ) : null}
                                            <>
                                              {index == 0 ? (
                                                <div
                                                  className={
                                                    this.props.styles
                                                      .hotel_remove_disabled
                                                  }
                                                >
                                                  X
                                                </div>
                                              ) : null}
                                              <div
                                                className={
                                                  this.props.styles
                                                    .hotel_adult_accomodation_tag
                                                }
                                              >
                                                <p>Room {index + 1}</p>
                                              </div>
                                            </>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            className={
                                              this.props.styles
                                                .hotel_accomodation_conf
                                            }
                                          >
                                            <span
                                              className={
                                                element.adultMinusCountDisable
                                                  ? this.props.styles
                                                      .disbale_traveller +
                                                    " " +
                                                    this.props.styles
                                                      .hotel_accomodation_icon
                                                  : this.props.styles
                                                      .hotel_accomodation_icon
                                              }
                                              onClick={() =>
                                                this.minusAccomodationCount(
                                                  element.id,
                                                  index,
                                                  "adult"
                                                )
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                id="minus"
                                              >
                                                <path
                                                  fill="#00A4F3"
                                                  d="M19,11H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"
                                                ></path>
                                              </svg>
                                            </span>
                                            <div
                                              className={
                                                this.props.styles.ac_count
                                              }
                                            >
                                              {element.adults}
                                            </div>
                                            <span
                                              className={
                                                element.adultAddCountDisable ||
                                                element.adult < 1
                                                  ? this.props.styles
                                                      .disbale_traveller +
                                                    " " +
                                                    this.props.styles
                                                      .hotel_accomodation_icon
                                                  : this.props.styles
                                                      .hotel_accomodation_icon
                                              }
                                              onClick={() =>
                                                this.addAccomodationCount(
                                                  element.id,
                                                  index,
                                                  "adult"
                                                )
                                              }
                                            >
                                              {/* <img src="/images/plus.png" className={this.this.props.styles.hotel_accomodation_icon} /> */}
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                id="plus"
                                              >
                                                <path
                                                  fill="#00A4F3"
                                                  d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"
                                                ></path>
                                              </svg>
                                            </span>
                                          </div>
                                        </td>
                                        {this.state.bookingType.length > 0 &&
                                          !this.state.bookingType[0].selected &&
                                          !this.state.bookingType[3]
                                            .selected && (
                                            <td>
                                              <div
                                                className={
                                                  this.props.styles
                                                    .hotel_accomodation_conf
                                                }
                                              >
                                                <span
                                                  className={
                                                    element.childrenMinusCountDisable ||
                                                    element.children < 1
                                                      ? this.props.styles
                                                          .disbale_traveller +
                                                        " " +
                                                        this.props.styles
                                                          .hotel_accomodation_icon
                                                      : this.props.styles
                                                          .hotel_accomodation_icon
                                                  }
                                                  onClick={() =>
                                                    this.minusAccomodationCount(
                                                      element.id,
                                                      index,
                                                      "children"
                                                    )
                                                  }
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    id="minus"
                                                  >
                                                    <path
                                                      fill="#00A4F3"
                                                      d="M19,11H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"
                                                    ></path>
                                                  </svg>
                                                </span>
                                                <div
                                                  className={
                                                    this.props.styles.ac_count
                                                  }
                                                >
                                                  {element.children}
                                                </div>
                                                <span
                                                  className={
                                                    element.childrenAddCountDisable
                                                      ? this.props.styles
                                                          .disbale_traveller +
                                                        " " +
                                                        this.props.styles
                                                          .hotel_accomodation_icon
                                                      : this.props.styles
                                                          .hotel_accomodation_icon
                                                  }
                                                  onClick={() =>
                                                    this.addAccomodationCount(
                                                      element.id,
                                                      index,
                                                      "children"
                                                    )
                                                  }
                                                >
                                                  {/* <img src="/images/plus.png" className={this.this.props.styles.hotel_accomodation_icon} /> */}
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    id="plus"
                                                  >
                                                    <path
                                                      fill="#00A4F3"
                                                      d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"
                                                    ></path>
                                                  </svg>
                                                </span>
                                              </div>
                                            </td>
                                          )}
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div
                                    className={
                                      this.props.styles.hotel_room_head
                                    }
                                  >
                                    {/* <div
                                      className={
                                        this.props.styles
                                          .hotel_adult_accomodation_tag
                                      }
                                    >
                                      <p>
                                      Room {index + 1} (Max 8)
                                      </p>
                                    </div> */}
                                    {/* {index > 0 ? (
                                    <div
                                      className={
                                        this.props.styles.hotel_room_remove
                                      }
                                      onClick={() =>
                                        this.removeRoomItem(element.id)
                                      }
                                    >
                                      Remove
                                    </div>
                                  ) : null} */}
                                  </div>

                                  <div
                                    className={
                                      this.props.styles.child_row_container
                                    }
                                  >
                                    {element.childDetails.length > 0 &&
                                      element.childDetails.map((item, ind) => {
                                        return (
                                          <div
                                            className={
                                              this.props.styles.child_row_main
                                            }
                                            key={ind}
                                          >
                                            <span>
                                              {/* <label>
                                              Child {ind + 1} Age
                                            </label> */}
                                              <input
                                                type="text"
                                                className={
                                                  item.isError === true
                                                    ? `${this.props.styles.selected_age} ${this.props.styles.selected_age_err}`
                                                    : this.props.styles
                                                        .selected_age
                                                }
                                                placeholder={
                                                  "Child" +
                                                  ` ${ind + 1} ` +
                                                  "Age"
                                                }
                                                value={item.age}
                                                onClick={() =>
                                                  this.isChildrenAge(
                                                    index,
                                                    ind,
                                                    "isOpen"
                                                  )
                                                }
                                                readOnly
                                              />
                                              {/* {item.isError === true ? (
                                              <span
                                                className={
                                                  this.props.styles
                                                    .err_message_text
                                                }
                                              >
                                                Please enter valid age
                                              </span>
                                            ) : null} */}
                                              <span
                                                className={
                                                  this.props.styles
                                                    .child_age_select_arrow
                                                }
                                                onClick={() =>
                                                  this.isChildrenAge(
                                                    index,
                                                    ind,
                                                    "isOpen"
                                                  )
                                                }
                                              >
                                                <svg
                                                  width="12"
                                                  height="12"
                                                  viewBox="0 0 11 7"
                                                  fill="currentFill"
                                                >
                                                  <path d="M5.464 6.389.839 1.769a.38.38 0 0 1 0-.535l.619-.623a.373.373 0 0 1 .531 0l3.74 3.73L9.47.61a.373.373 0 0 1 .531 0l.619.623a.38.38 0 0 1 0 .535l-4.624 4.62a.373.373 0 0 1-.531 0Z"></path>
                                                </svg>
                                              </span>
                                            </span>
                                            {item.isOpen === true ? (
                                              <div
                                                className={
                                                  this.props.styles
                                                    .age_list_cont
                                                }
                                              >
                                                <div
                                                  className={
                                                    this.props.styles
                                                      .age_list_main
                                                  }
                                                >
                                                  {childAgeList.map(
                                                    (ele, i) => {
                                                      return (
                                                        <div
                                                          key={i}
                                                          className={
                                                            this.props.styles
                                                              .age_list_ele
                                                          }
                                                          onClick={() =>
                                                            this.isChildrenAge(
                                                              index,
                                                              ind,
                                                              "clickAge",
                                                              ele
                                                            )
                                                          }
                                                        >
                                                          <span>{ele}</span>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              );
                            })}
                            {this.state.roomList.length < 4 ? (
                              <div
                                className={this.props.styles.hotel_add_rooms}
                                onClick={() => {
                                  this.setState({
                                    roomList: [
                                      ...this.state.roomList,
                                      {
                                        id: this.state.roomList.length + 1,
                                        adults: 1,
                                        children: 0,
                                        adultAddCountDisable: false,
                                        adultMinusCountDisable: true,
                                        childrenAddCountDisable: false,
                                        childrenMinusCountDisable: true,
                                        childDetails: [],
                                      },
                                    ],
                                  });
                                }}
                              >
                                {/* <span> + </span> */}
                                <p style={{ paddingLeft: 3 }}>ADD ROOM </p>
                                {/* <span > - </span> */}
                              </div>
                            ) : null}
                          </div>
                          <div className={this.props.styles.done_button_main}>
                            <input
                              tabindex="4"
                              value="Done"
                              className={this.props.styles.done_button}
                              readOnly
                              onClick={() => this.onClickDoneButton()}
                              onBlur={this.focusOutDone}
                            />
                            {/* <button  className={this.props.styles.done_button} onClick={() => this.onClickDoneButton()}>Done</button> */}
                          </div>
                        </div>
                      ) : null}
                    </div>
                    {this.state.advSearch && (
                      <HotelAdvSearch
                        {...this.state}
                        styles={this.props.styles}
                        onClickTraveller={this.onClickTraveller}
                        onClickAdvSearch={this.onClickAdvSearch}
                        onClickSearchHotel={this.onClickSearchHotel}
                        onTickAdvSearch={this.onTickAdvSearch}
                        onClickNationality={this.onClickNationality}
                        applyb2bFilters={this.applyb2bFilters}
                        handleCheckboxSelection={this.handleCheckboxSelection}
                        selectedCheckBoxes={this.state.selectedCheckBoxes}
                        handleStarCheck={this.handleStarCheck}
                        isOneStar={this.state.isOneStar}
                        isTwoStar={this.state.isTwoStar}
                        isThreeStar={this.state.isThreeStar}
                        isFourStar={this.state.isFourStar}
                        isFiveStar={this.state.isFiveStar}
                        addGuestId={this.adGuestId}
                        removeGuestId={this.rmGuestId}
                        listWrapper={this.advanceSearchWrapper}
                        guestWrapper={this.guestDetailWrapper}
                        isOffline={this.props.isOffline}
                        errorMessage={"Select Traveler"}
                        isError={this.state.isError.selectedGuest}
                        isStarSearch={this.state.showStarSearch}
                        onClickStarSearch={this.onClickStarSearch}
                        isRoomTypeSearch={this.state.showRoomTypeSeach}
                        onClickRoomTypeSearch={this.onClickRoomTypeSearch}
                        isBreakfastSearch={this.state.showBreakfastSearch}
                        onClickBreakfastSearch={this.onClickBreakfastSearch}
                        allStar={this.state.allStar}
                        rtSearchWrapper={this.rtSearchWrapper}
                        bfSearchWrapper={this.bfSearchWrapper}
                        starSearchWrapper={this.starSearchWrapper}
                        handleBreakfastSelection={this.handleBreakfastSelection}
                        handleBreakfastAllSelection={this.handleBreakfastAllSelection}
                      />
                    )}
                    <div
                      className={`${this.props.styles.hotel_search_details_row} ${this.props.styles.hotel_search_details_row_button}`}
                    >
                      {/* {!this.props.isSRP &&
                    this.props?.userProfile?.type === "B2B" && (
                      <div className={this.props.styles.nationality_cnt_wd}>
                        <div className={this.props.styles.nationality_wrap}> */}
                      {/* <label htmlFor="fname" className="lablename-htl">Select Nationality</label> */}
                      {/* <input type="text" className={this.props.styles.input_nationality_wd} name="fname" id="nationallity" placeholder="Select Nationality" onkeyup={{}} autoComplete="off" />
                                                <span className={this.props.styles.pg_down_arrow}> <i className="fa fa-caret-down" onClick={() => this.onClickNationality()} aria-hidden="true" /></span> */}
                      {/* <CountryDropdownComp
                                                    countryFlag={this.state.originCountries}
                                                    searchText={""}
                                                    selectCountry={this.onClickNationalityHandler}
                                                    selectedCountry={this.state.selectedNationality}
                                                    onChangeInputCountryCode={this.onChangeInputNationality}
                                                    placeholder={'Select Nationality'}
                                                    isSignUpNationality={false}
                                                    isB2B={true}
                                                    {...this.props.Countrystyles}
                                                // {...this.props.data.Countrystyles}
                                                /> */}
                      {/* <NationalityDropdownComp
                            countryFlag={this.state.originCountries}
                            searchText={""}
                            selectNationality={this.selectNationality}
                            selectedNationality={this.state.selectedNationality}
                            onChangeNationalityCode={
                              this.onChangeNationalityCode
                            }
                            placeholder={"Select Nationality"}
                            isSignUpNationality={false}
                            isB2B={true}
                            errorMessage={"Select Nationality"}
                            isError={this.state.isError.selectedNationality}
                            styles={this.props.styles}
                            {...this.props.Countrystyles}
                          /> */}
                      {/* </div> */}
                      {/* {this.state.nationallitySearch &&

                                                <div id="myNation" className="dropdown-content-Guest dropdown-content-nation dropdown-content-nation-htl">
                                                    <div className={this.props.styles.inputsearch_result}><input type="text" placeholder="Search.." id="myInputNation" onkeyup={{}} />
                                                    </div>
                                                    <div id="suggested_nation" />
                                                </div>
                                            } */}
                      {/* </div>
                    )} */}
                      {/* <div className={`${this.props?.userProfile?.type === 'B2B' ? this.props.styles.hotel_search_class : this.props.styles.hotel_search_details_row_mg}`}> */}

                      <div
                        className={`${
                          this.props.isSRP
                            ? this.props.styles.hotel_search_class
                            : this.props.styles.hotel_search_btnClass
                        }`}
                      >
                        {!this.props.offlineType ? (
                          <button
                            tabindex="5"
                            id="hotels_search_btn"
                            className={`${
                              this.props.styles.hotel_search_widget_btn
                            } ${this.state.btnLoader ? "loading" : ""}`}
                            onClick={() => this.onClickSearchHotel()}
                          >
                            {this.props.isOffline ? "Proceed" : "Search"}
                          </button>
                        ) : null}

                        {this.props.offlineType == "Enquiry" ? (
                          <button
                            tabindex="5"
                            className={
                              this.props.styles.hotel_search_widget_btn
                            }
                            onClick={() => this.onButtonEnquiry()}
                            disabled={this.state.isLoading}
                          >
                            {this.state.isLoading ? "Loading..." : "Enquiry"}
                            {/* {this.props.isOffline ?  "Offline" : "Search"} */}
                          </button>
                        ) : null}

                        {/* <svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 width="200px" height="200px" viewBox="0 0 200 200" enable-background="new 0 0 200 200">
<g>
	<path fill="#ffffff" d="M109.039,50.665C66.53,11.72,8.749,69.501,47.694,112.01c8.4,8.4,19.6,12.728,30.545,12.728
		C116.421,124.737,136.275,77.646,109.039,50.665z M105.221,108.192c-14.254,14.763-39.708,14.763-53.963,0
		C27.331,84.52,44.64,42.774,78.239,43.029C111.839,42.774,129.148,84.52,105.221,108.192z"/>
	<path fill="#ffffff" d="M169.875,155.537l-34.363-34.363c-3.055-3.055-7.382-3.563-10.437-1.527l-6.108-6.109
		c38.69-52.436-29.782-113.526-77.382-68.981c-20.363,20.363-20.363,53.2,0,73.308c18.582,18.582,48.363,20.109,68.727,4.073
		l6.364,6.363c-1.782,2.8-1.273,7.127,1.781,10.182l34.363,34.363c1.782,1.782,4.328,2.801,6.364,2.801
		c1.781,0,3.563-0.51,4.836-1.782l6.873-6.873C173.693,163.938,173.185,158.846,169.875,155.537z M45.149,114.301
		c-29.527-29.272-7.891-80.181,33.09-79.926c11.964,0,23.927,4.582,33.091,13.745C153.584,93.938,90.967,156.556,45.149,114.301z
		 M114.894,117.864c0.255-0.254,0.509-0.509,0.764-0.764l5.854,5.854l-1.527,1.527l-5.854-5.854
		C114.385,118.374,114.639,118.119,114.894,117.864z M167.33,163.174l-6.873,6.872c-0.764,0.764-2.546,0.509-4.072-1.018
		l-34.364-34.364c-1.781-2.036-1.526-3.563-0.254-4.836l5.091-5.091l1.018-1.019c1.273-1.018,2.801-0.254,4.073,1.019l34.363,34.363
		C167.839,160.628,168.094,162.41,167.33,163.174z"/>
</g>
</svg> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.onLoadPopup ? (
          <ModalPopupComponent
            isMobile={false}
            isPopup={true}
            onClosePopup={() => {
              this.setState({
                onLoadPopup: false,
              });
            }}
            modalCss={this.props.modalCss}
          >
            <div className={this.props.styles.enquiy_container}>
              <div className={this.props.styles.send_success}>
                <img src="theme4/tick.png" alt="send quote" />
                <div className={this.props.styles.send_lbl}>Send Enquiry</div>
              </div>
              <div className={this.props.styles.enquire_wrap}>
                <span className={this.props.styles.quote_lblTitle}>
                  Enquiry ID: {this.state?.enquiry_id}
                </span>
              </div>
              <span className={this.props.styles.quote_success}>
                Enquiry Request Successful
              </span>
              <div className={this.props.styles.btn_container}>
                <button
                  className={this.props.styles.ok_button}
                  // onClick={() => {
                  // this.closeEnquiry()
                  // }}
                  onClick={() => {
                    window.location.reload();
                    this.setState({
                      onLoadPopup: false,
                    });
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </ModalPopupComponent>
        ) : null}

        {this.state.showbookingTypeError ? (
          <ModalPopupComponent
            isMobile={true}
            isPopup={true}
            onClosePopup={() => {
              this.setState({
                showbookingTypeError: false,
              });
            }}
            modalCss={this.props.modalCss}
          >
            {this.modalPopupSwitch()}
          </ModalPopupComponent>
        ) : null}
      </>
    );
  }
}